export const getFileExt = (fname: string) => {
  // https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript
  return fname.slice(((fname.lastIndexOf('.') - 1) >>> 0) + 2);
};
